import React from 'react';
import { IonImg, IonGrid, IonRow, IonCol } from '@ionic/react';

export const MessageComponent = ({
    message,
    subtitle,
    urlImage,
    children,
    svg
}) => {

    return (
        <>
            <IonGrid>
                <IonRow className="grid-rows-3 state--msg">
                    <IonCol>
                        <p className="subtitle">{subtitle} {message}</p>
                    </IonCol>
                    <IonCol className="text-align-center">
                        { 
                            urlImage && <IonImg className="msg__img" src={ urlImage } />
                        }

                        {
                            svg
                        }
                    </IonCol>
                    <IonCol className="dispFlex-justCenter">
                        {children}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </>
    )
}
